import React from 'react'

import blog1 from './hero.webp';

import StartFooterCTA from './StartFooterCTA.js'


export default class extends React.Component {
  render() {
    document.title = "Blog · Citrus by Polymedia";
    let alt_nl = document.createElement('link');alt_nl.rel = 'alternate';alt_nl.hreflang = 'x-default';alt_nl.href = 'https://citrus.polymedia.nl/blog';
    document.getElementsByTagName('title')[0].after(alt_nl);
    let alt_en = document.createElement('link');alt_en.rel = 'alternate';alt_en.hreflang = 'en';alt_en.href = 'https://citrus.polymedia.nl/en/blog';
    document.getElementsByTagName('title')[0].after(alt_en);
    return (
      <div>

        <div className="full greyish blog">
          <div className="wrap wrap-thin">

            <article>
              <img src={blog1} alt="citrus.polymedia.nl | would you recommend this article to friends?" className="screenshot" />
              <h1>Citrus by Polymedia released!</h1>
              <small><time datetime="2024-04-10">10-04-2024</time> | <a href="https://www.linkedin.com/in/peterdotplus/" target="_blank" rel="noopener noreferrer">Peter van der Meer</a></small>
              <p>It is possible to integrate polls into websites, and to share them with a link. To start, only regular polls with one question and a maximum of three options.</p>
            </article>

          </div>
        </div>

        <StartFooterCTA lang={this.props.app_language} openModal={this.props.openModal} />

      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./src/containers/StartPages/Blog-EN.js